module.exports = function(app) {
    app.directive('wellDivOne', function() {

        return {
            restrict: 'A',
            replace: true,
            /*template: require('directives/wellDivOne.html'),*/
            templateUrl: 'wellness.appTemplate.html/chmhom/directives/wellDivOne',

            // scope: {},
            controller: ['$scope',
                function($scope) {

                }
            ]
        };
    });
}